import { GridValidRowModel } from '@mui/x-data-grid';
import { GestDataGridPro, IGestDataGridProProps, Title } from "@shared/library";
import { Property } from 'csstype';
import { ISummary } from "../../models/components/components";

interface IDataGridsLayoutProps<T extends GridValidRowModel> {
    area?: ISummary<T>;
    layout?: Property.GridTemplate;
    gridProps?: IGestDataGridProProps<T>;
}

const DataGridsLayout = <T extends GridValidRowModel>(props: IDataGridsLayoutProps<T>) =>
    <div className="flex fitContent">
        {props.area?.content?.Tabs
            ?.filter(t => t.InitRows.length)
            .map(t =>
                <div className="flex-column fitContent">
                    <div className="fullw justify-content-between align-items-center">
                        <Title size="large">{t.TabName || props.area!.label}</Title>
                        {props.area!.content!.actions}
                    </div>

                    <GestDataGridPro
                        key={t.TabName}
                        {...props.gridProps}
                        columns={props.area!.content!.Columns ?? []}
                        rows={t.InitRows}
                    />
                </div>
            )
        }
    </div>;
export default DataGridsLayout;